export default __webpack_public_path__ + "static/hero-mobile-18c465a0a9b480ed5bfa586ccf8b02c8.png";